/**
 * Original work Copyright (c) 2019 Burst Apps Team
 */

/**
 * Constants for leasing subtypes
 *
 * @category transaction-types
 */
export enum TransactionLeasingSubtype {
    Ordinary = 0
}

